import { types } from 'src/store/feature-flags/feature-flags.types';

export const initialState = {
    ready: false,
    loading: false,
    values: {},
    error: '',
};

const featureFlags = (state = initialState, { type, payload }) => {
    switch (type) {

    case types.FEATURE_FLAGS_REQUEST:
        return {
            ...state,
            loading: true,
            ready: false,
            error: '',
        };

    case types.FEATURE_FLAGS_REFRESH_REQUEST:
        return {
            ...state,
            loading: true,
            error: '',
        };

    case types.FEATURE_FLAGS_SUCCESS:
        return {
            ...state,
            loading: false,
            ready: true,
            values: payload,
            error: '',
        };

    case types.FEATURE_FLAGS_ERROR:
        return {
            ...state,
            loading: false,
            error: typeof payload === 'string' ? payload : 'Feature flag initialization failed',
        };

    case types.CLEAR_FEATURE_FLAGS:
        return initialState;

    default:
        return state;
    }
};

export default featureFlags;
